module.exports = __webpack_public_path__ + "static/media/Step0.df7eceac.png";